import { styled } from "@mui/system"
import { Box, Typography } from "@mui/material"
export const HeaderContainer = styled(Box)`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
    padding-bottom: 16px;
    border-bottom: 1px solid #e0e0e0;
`;

export const SectionTitle = styled(Typography)`
    font-size: 1.1rem;
    font-weight: 400;
    color: "var(--brand-text-sec)";
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const FieldContainer = styled(Box)`
    display: grid;
    grid-template-columns: 2fr 1fr;
    gap: 20px;
    margin-bottom: 24px;
`;

export const FieldGroup = styled(Box)`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
`;